import { resolvePortalHost } from "./portalUtils.js";
import { getPortalSession, getPortalSessionForAccount } from "./portalSession.js";

export const AGGREGATOR_SELECTED_GROWER_KEY =
  "fieldprint.aggregator.selectedGrower";
export const AGGREGATOR_SELECTED_GROWER_EVENT =
  "fieldprint:aggregator-selected-grower";

export const DATA_READ_SCOPE = "data.read";
export const DATA_WRITE_SCOPE = "data.write";
export const IMPORT_WRITE_SCOPE = "import.write";
export const RECONCILIATION_WRITE_SCOPE = "reconciliation.write";
export const ALL_SCOPE = "all";

export const DELEGATION_SCOPE_LABELS = {
  [DATA_READ_SCOPE]: "View records",
  [DATA_WRITE_SCOPE]: "Update records",
  [IMPORT_WRITE_SCOPE]: "Run imports",
  [RECONCILIATION_WRITE_SCOPE]: "Resolve conflicts",
  [ALL_SCOPE]: "All permissions",
};

const SCOPE_ALIASES = {
  imports: IMPORT_WRITE_SCOPE,
  import: IMPORT_WRITE_SCOPE,
  import_write: IMPORT_WRITE_SCOPE,
  data_read: DATA_READ_SCOPE,
  data_write: DATA_WRITE_SCOPE,
  reconciliation: RECONCILIATION_WRITE_SCOPE,
  reconciliation_write: RECONCILIATION_WRITE_SCOPE,
};

export function normalizeDelegationScope(scope) {
  const normalized = String(scope || "")
    .trim()
    .toLowerCase()
    .replaceAll(" ", "_")
    .replaceAll("-", "_");
  return SCOPE_ALIASES[normalized] || normalized;
}

export function selectedGrowerHasScope(grower, requiredScope) {
  if (!grower) {
    return false;
  }
  const scope = Array.isArray(grower.scope) ? grower.scope : [];
  const normalized = scope.map(normalizeDelegationScope);
  return (
    normalized.includes(ALL_SCOPE) ||
    normalized.includes(normalizeDelegationScope(requiredScope))
  );
}

export function selectedGrowerHasAnyScope(grower, requiredScopes = []) {
  return requiredScopes.some((scope) => selectedGrowerHasScope(grower, scope));
}

export function formatDelegationScope(scope) {
  const normalized = normalizeDelegationScope(scope);
  return DELEGATION_SCOPE_LABELS[normalized] || normalized.replace(".", " ");
}

export function readSelectedAggregatorGrower() {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(AGGREGATOR_SELECTED_GROWER_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch (error) {
    return null;
  }
}

export function writeSelectedAggregatorGrower(grower) {
  if (typeof window === "undefined") {
    return;
  }

  if (!grower) {
    window.localStorage.removeItem(AGGREGATOR_SELECTED_GROWER_KEY);
    window.dispatchEvent(new CustomEvent(AGGREGATOR_SELECTED_GROWER_EVENT));
    return;
  }

  window.localStorage.setItem(
    AGGREGATOR_SELECTED_GROWER_KEY,
    JSON.stringify(grower)
  );
  window.dispatchEvent(new CustomEvent(AGGREGATOR_SELECTED_GROWER_EVENT));
}

export function isAggregatorPortalHost(hostname = "", env = process.env, account) {
  const session = account === undefined ? getPortalSession() : getPortalSessionForAccount(account);
  return (session.portal || resolvePortalHost(hostname, env).portal) === "aggregator";
}
